import { SingleEntityDataAdapter, SingleEntityState } from './types';

export const getSingleEntityDataAdapter = <Entity>(
  initialState: SingleEntityState<Entity>,
): SingleEntityDataAdapter<Entity> => ({
  save: (state, data) => ({
    ...state,
    data: data,
  }),
  update: (state, data) => ({
    ...state,
    data: {
      ...state.data!,
      ...data,
    },
  }),
  reset: () => initialState,
});
